import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'

import { LayoutPlain, Header } from 'components/layout'
import { MaterialLoader } from 'components/loaders'
import { apiPayment } from 'helpers/decorators/api'
import PropTypes from 'prop-types'

@apiPayment()
class PaymentInit extends Component {
  static propTypes = {
    intializePaypal: PropTypes.func
  }

  constructor(props) {
    super(props)

    !__SERVER__ && props.intializePaypal()
  }

  render() {
    return (
      <LayoutPlain
        header={<Header isLocaleHidden />}
        body={[
          <div>
            <h1>
              <MaterialLoader />{' '}
              <span style={{ marginLeft: 10, position: 'relative', top: -7 }}>
                <FormattedMessage
                  id="label.loading_paypal_gateway"
                  defaultMessage="Loading Paypal Gateway"
                />
              </span>
            </h1>
          </div>
        ]}
      />
    )
  }
}

export default PaymentInit
